/* Section: search — overlay using Shopify predictive search API. */
(() => {
  const overlay = document.querySelector('[data-section="search"]');
  if (!overlay) return;

  const SUGGESTIONS = ["Neon Moon", "Boot Scootin'", "Holiday", "Trinidad", "Sale"];

  const input = overlay.querySelector('.search-panel__field input');
  const closeBtn = overlay.querySelector('.search-panel__close');
  const body = overlay.querySelector('[data-search-body]');

  function open() {
    overlay.classList.add('search-overlay--open');
    document.body.style.overflow = 'hidden';
    renderEmpty();
    requestAnimationFrame(() => input.focus());
  }
  function close() {
    overlay.classList.remove('search-overlay--open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-search]')) { e.preventDefault(); open(); }
  });
  closeBtn?.addEventListener('click', close);
  overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('search-overlay--open')) close();
  });

  let t = null;
  input?.addEventListener('input', () => {
    clearTimeout(t);
    const q = input.value;
    t = setTimeout(() => runSearch(q), 200);
  });

  async function runSearch(qRaw) {
    const q = (qRaw || '').trim();
    if (!q) return renderEmpty();
    try {
      const url = new URL('/search/suggest.json', window.location.origin);
      url.searchParams.set('q', q);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '8');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      const res = await fetch(url.toString());
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const products = data.resources?.results?.products || [];
      if (!products.length) {
        body.innerHTML = `
          <p class="search-panel__meta">No matches</p>
          <div class="search-panel__empty">
            Nothing for "<strong>${escapeHtml(qRaw)}</strong>". Try a broader term or one of these:
            <div class="search-panel__suggestions">
              ${SUGGESTIONS.map((s) => `<button type="button" data-suggest="${escapeHtml(s)}">${escapeHtml(s)}</button>`).join('')}
            </div>
          </div>
        `;
        wireSuggestions();
        return;
      }
      body.innerHTML = `
        <p class="search-panel__meta">${products.length} hat${products.length === 1 ? '' : 's'} match "${escapeHtml(qRaw)}"</p>
        <div class="search-panel__results">
          ${products.map(cardHtml).join('')}
        </div>
        <p style="margin-top:var(--sp-5);text-align:center;">
          <a href="/search?q=${encodeURIComponent(qRaw)}">View all results →</a>
        </p>
      `;
    } catch (err) {
      console.error('[search] failed:', err);
      body.innerHTML = `<p class="search-panel__meta">Search is unavailable right now.</p>`;
    }
  }

  function renderEmpty() {
    body.innerHTML = `
      <p class="search-panel__meta">Popular right now</p>
      <div class="search-panel__suggestions">
        ${SUGGESTIONS.map((s) => `<button type="button" data-suggest="${escapeHtml(s)}">${escapeHtml(s)}</button>`).join('')}
      </div>
    `;
    wireSuggestions();
  }

  function wireSuggestions() {
    body.querySelectorAll('[data-suggest]').forEach((b) => {
      b.addEventListener('click', () => {
        const term = b.getAttribute('data-suggest') || '';
        input.value = term;
        runSearch(term);
      });
    });
  }

  function cardHtml(p) {
    const onSale = p.compare_at_price_min && Number(p.compare_at_price_min) > Number(p.price);
    return `
      <article class="product-card">
        <div class="product-card__media">
          <a class="product-card__link" href="${escapeHtml(p.url)}" aria-label="${escapeHtml(p.title)}"></a>
          ${onSale ? '<span class="product-card__badge">Sale</span>' : ''}
          <img src="${escapeHtml(p.featured_image?.url || p.image || '')}" alt="${escapeHtml(p.title)}" loading="lazy" />
        </div>
        <div class="product-card__body">
          <h3 class="product-card__title"><a href="${escapeHtml(p.url)}">${escapeHtml(p.title)}</a></h3>
          <p class="product-card__price">
            <span class="product-card__price-now">${escapeHtml(p.price)}</span>
            ${onSale ? `<span class="product-card__price-was">${escapeHtml(p.compare_at_price_min)}</span>` : ''}
          </p>
        </div>
      </article>
    `;
  }

  function escapeHtml(s) {
    return String(s ?? '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
})();
